import { createContext } from 'react';
import { User } from '@auth0/auth0-react';

export interface AuthContextValue {
  isLoading: boolean;
  isAuthenticated: boolean;
  isViewOnly: boolean;
  error?: Error;
  user?: User;
  getAccessToken: () => Promise<string>;
  requestViewOnly: () => void;
  login: () => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export interface AccessTokenClaims {
  wrt?: boolean;
}
